<template>
  <div class="comment">
    <div class="comment__avatar">
      <img :src="comment.author.avatar" />
    </div>
    <div class="comment__body">
      <div class="comment__header">
        <Title markup="h4">
          {{ comment.author.display_name }}
        </Title>
        <div class="comment__date">
          Il y a 2 semaines
        </div>
        <div class="comment__rate" v-if="comment.rating">
          <star-rating
            :rating="comment.rating"
            :increment="0.5"
            :star-size="15"
            read-only
          ></star-rating>
        </div>
      </div>
      <div class="comment__content" v-html="comment.content"></div>
      <div class="comment__actions" v-if="userIsLogged()">
        <ui-button
          icon="corner-down-right"
          text
          size="s"
          @click="answer"
          v-if="comment.depth === 0"
        >
          Répondre
        </ui-button>

        <div class="comment__form" v-if="comment.depth === 0">
          <vue-slide-up-down :active="showForm">
            <CommentForm
              @submit="newComment()"
              :recipe="comment.post_id"
              :parent="comment.id"
            />
          </vue-slide-up-down>
        </div>
      </div>
      <CommentItem
        v-for="comment in comment.answers"
        :comment="comment"
        :key="'comment' + comment.id"
      />
    </div>
  </div>
</template>
<script>
import UiButton from "@/components/ui/UiButton.vue";
import Title from "@/components/ui/Title.vue";
import CommentForm from "@/components/comment/CommentForm.vue";
import StarRating from "vue-star-rating";
import VueSlideUpDown from "vue-slide-up-down";

export default {
  components: {
    CommentItem: () => import("./CommentItem.vue"),
    CommentForm,
    VueSlideUpDown,
    StarRating,
    Title,
    UiButton
  },
  props: {
    comment: { required: true }
  },
  data() {
    return {
      showForm: false
    };
  },
  mounted() {},
  methods: {
    answer() {
      this.showForm = !this.showForm;
    },
    newComment() {
      this.$emit("submit");
      this.showForm = false;
    }
  }
};
</script>
<style lang="scss">
.comment {
  background: $white;
  border-radius: $box-radius;
  overflow: hidden;
  margin: 20px 0;
  padding: 10px;
  box-shadow: $box-shadow;
  display: flex;
  position: relative;
  &__avatar {
    border-radius: 100px;
    overflow: hidden;
    margin-right: 10px;
    width: 70px;
    height: 70px;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  &__header {
    flex-grow: 1;
    display: flex;
    align-items: baseline;
    .titleblock {
      margin-bottom: 0;
    }
  }
  &__date {
    margin-left: 10px;
    color: $gray;
    font-size: 0.8em;
  }
  &__rate {
    position: absolute;
    right: 0;
    margin-left: auto;
    margin-right: 20px;
    .vue-star-rating-star {
      display: flex !important;
    }
    .vue-star-rating-rating-text {
      margin-top: 0 !important;
      position: relative;
      top: 0.1em;
      color: $gray;
    }
  }
  &__body {
    flex-grow: 1;
  }
  &__actions {
    margin-top: 20px;
  }
  &__content {
    margin-top: 1em;
    :first-child {
      margin-top: 0;
    }
    :last-child {
      margin-bottom: 0;
    }
  }
  .comment {
    margin-left: -50px;
    box-shadow: none;
    padding: 0;
  }

  &__form {
    position: relative;
    overflow: hidden;
  }
}
</style>
